<template>
  <div>
    <div id="content" v-html="content" v-lazy-container="{ selector: 'img' }"></div>
    <!-- <div class="toast" v-show="showToast">{{ toastMsg }}</div> -->
    <div class="no-content" v-show="showNoContent">
      <img src="~@/assets/none-content.png" alt="" />
      <p>页面好像丢失了，稍后再试试吧</p>
    </div>
  </div>
</template>

<script>
import { getContent } from '@/request/home'
export default {
  name: 'AgreementHome',

  data() {
    return {
      content: '',
      showToast: false,
      showNoContent: false,
      toastMsg: '',
    }
  },

  async mounted() {
    const id = this.$route.params.id
    const { data, status, msg } = await getContent(id)
    if (status === 200) {
      this.content = data.content.replace(/src/g,'data-src')
      document.title = data.title
			console.log('this.cont',this.content)
    } else {
      this.showNoContent = true
      this.toastMsg = msg
    }
  },

  methods: {},
}
</script>

<style>
#content img {
  max-width: calc(100vw - 2rem);
}
.no-content {
  text-align: center;
  margin-top: 3rem;
}
.no-content img {
  width: 15rem;
  margin: 0 auto;
}
.toast {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 8px 20px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
}
</style>
